const mixin = {
  props: {
    openOnInit: {
      type: Boolean,
      default: false
    },
    toggleSubscribeKey: {
      type: String,
      default: null
    }
  },
  data: () => ({
    isOpen: null
  }),
  methods: {
    toggleAccordion(value) {
      this.isOpen = value || !this.isOpen
    }
  },
  mounted() {
    this.isOpen = this.openOnInit

    if (this.toggleSubscribeKey) {
      this.subscribe(this.toggleSubscribeKey, (value) => {
        this.isOpen = value
      })
    }
  }
}

export default mixin
